var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuthNfc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 154 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.987 16.7415C90.3387 4.27746 63.6613 4.27746 42.0133 16.7415C20.3653 29.2055 7.02668 52.3841 7.02668 77.3121C7.02668 102.24 20.3653 125.419 42.0133 137.883C63.6613 150.347 90.3387 150.347 111.987 137.883C133.635 125.419 146.973 102.24 146.973 77.3121C146.973 52.3841 133.635 29.2055 111.987 16.7415ZM115.267 11.0561C91.6507 -2.71988 62.3493 -2.71988 38.7333 11.0561C15.1173 24.8321 0.466675 49.9788 0.466675 77.3121C0.466675 104.645 15.1173 130.011 38.7333 143.568C62.3493 157.344 91.6507 157.344 115.267 143.568C138.883 129.792 153.533 104.645 153.533 77.3121C153.533 49.9788 138.883 24.6135 115.267 11.0561Z",
    fill: "url(#paint0_linear_190_348)",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1839 91.9628C81.3733 87.1521 77 82.7788 72.408 78.1868C72.408 79.4988 72.408 80.5921 72.408 81.6854C72.408 84.5281 72.408 87.3708 72.408 90.2134C72.408 90.6508 72.6266 91.5254 73.0639 91.7441C80.2799 99.1788 87.7146 106.395 94.9306 113.611C95.1493 113.829 95.1493 113.829 95.5866 114.048C95.5866 113.611 95.5866 113.173 95.5866 112.736C95.5866 91.7441 95.5866 70.7521 95.5866 49.7601C95.5866 45.1681 94.2746 40.7948 91.6506 36.8588C91.4319 36.4214 91.2133 36.2028 90.9946 35.7654C90.9946 35.5468 91.2133 35.5468 91.2133 35.5468C97.5546 35.5468 104.115 35.3281 110.456 35.5468C115.485 35.7654 118.765 39.9201 118.765 44.9494C118.765 66.3788 118.765 88.0268 118.765 109.456C118.765 114.923 114.829 118.859 109.363 118.859C100.179 118.859 90.9946 118.859 81.5919 118.859C73.9386 118.859 67.816 112.736 67.816 105.301C67.816 91.3068 67.816 77.5308 67.816 63.5361C67.816 63.3174 67.816 63.0988 67.816 62.6614C72.408 67.2534 76.9999 71.8454 81.5919 76.4374C81.5919 74.6881 81.5919 73.3761 81.5919 72.0641C81.5919 69.4401 81.5919 66.8161 81.5919 64.1921C81.5919 63.7548 81.3733 63.0988 80.936 62.6614C73.72 55.4454 66.504 48.2294 59.288 40.7948C59.0693 40.5761 58.8506 40.5761 58.6319 40.1388C58.6319 40.7948 58.6319 41.2321 58.6319 41.8881C58.6319 62.6614 58.6319 83.4348 58.6319 104.208C58.6319 109.237 59.944 113.829 62.7866 118.203C63.0053 118.421 63.0053 118.64 63.2239 118.859C62.7866 118.859 62.3493 118.859 61.9119 118.859C56.2266 118.859 50.5413 118.859 44.8559 118.859C39.3893 118.859 35.2346 114.923 35.2346 109.456C35.2346 88.0268 35.2346 66.3788 35.2346 44.9494C35.2346 39.4828 39.3893 35.5468 44.6373 35.5468C53.8213 35.5468 63.0053 35.5468 72.1893 35.5468C79.8426 35.5468 85.9653 41.2321 86.1839 48.8854C86.4026 62.8801 86.1839 77.0934 86.1839 91.0881C86.1839 91.0881 86.1839 91.3068 86.1839 91.9628Z",
    fill: "url(#paint1_linear_190_348)",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_190_348",
    x1: 23.5393,
    y1: 125.668,
    x2: 130.016,
    y2: 29.3922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61ADFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFADFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_190_348",
    x1: 35.2403,
    y1: 77.2104,
    x2: 118.76,
    y2: 77.2104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFADFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61ADFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthNfc);
export default __webpack_public_path__ + "static/media/auth_nfc.74d32928f5cb72b7f3a29829a695050f.svg";
export { ForwardRef as ReactComponent };